export default __webpack_public_path__ + "static/media/Skammestein.1b2e77e6.jpg";